

































import { Component, Prop, Vue } from "vue-property-decorator";
import ImageString from "@/components/ImageString.vue";
import QuestionResultModel from "@/model/QuestionResultModel";
@Component({
  components: { ImageString }
})
export default class QuestionResult extends Vue {
  @Prop()
  questionResult!: QuestionResultModel;

  @Prop()
  collapsed: boolean = true;

  toggleCollapse() {
    this.collapsed = !this.collapsed;
  }
}
